import cn from 'classnames/bind';
import PropTypes from 'prop-types';
import { classNameType, getColorType } from 'utils/types';

import s from './RoundedHeader.module.scss';

const cx = cn.bind(s);

const RoundedHeader = ({
  className, color, children, bgImage, ...attrs
}) => (
  <div
    style={bgImage && { '--page-header-background': `url(${bgImage})` }}
    className={cx(className, color, 'header', { bgImage })}
    {...attrs}
  >
    <div className={cx('content')}>
      {children}
    </div>
  </div>
);
RoundedHeader.propTypes = {
  className: classNameType,
  color: getColorType(['white']),
  bgImage: PropTypes.string,
};

export default RoundedHeader;
